import { render, staticRenderFns } from "./CommentsPost.vue?vue&type=template&id=2acb10fb&"
import script from "./CommentsPost.vue?vue&type=script&lang=js&"
export * from "./CommentsPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports